/**
 * The Texts card's one-line summary. Pinned rules of one prompt group are
 * still ONE group (QA 18/10/2026: two pinned rules read "2 groups").
 * For Media Devoted | Created By Ciro Autiero
 */
import type { TreeGroupLike } from '@/features/campaign-texts/utils/group-tree.utils';

import type { ContainerEditor } from '../state/useContainerEditor';
import { picksFromIds } from './picks/prompt-group-picks';

type Creative = ContainerEditor['draft']['creative'];

const plural = (n: number, noun: string) => `${n} ${noun}${n === 1 ? '' : 's'}`;

function groupsPart(creative: Creative, tree: TreeGroupLike[]): string {
  if (creative.textGroupIds.length === 0) return 'no groups yet';
  const picks = picksFromIds(creative.textGroupIds, tree);
  const pinned = picks.reduce((n, p) => n + p.ruleIds.length, 0);
  const rules = pinned > 0 ? ` (${plural(pinned, 'pinned rule')})` : '';
  const order = creative.textGroupIds.length > 1 ? ` · ${creative.assignment === 'ROTATE' ? 'rotate' : 'random'}` : '';
  return `${plural(picks.length, 'group')}${rules}${order}`;
}

export function textsSummary(creative: Creative, tree: TreeGroupLike[]): string {
  const mode = creative.textMode === 'SHARED' ? 'shared set' : 'unique per drop';
  return `${groupsPart(creative, tree)} · ${mode} · ${plural(creative.amount, 'text')}`;
}
